import updateCartViews from "./eCommerce";
export default class CartsList extends HTMLDivElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.events();
    }

    getSelectorResetCart() {
        return 'a.delete';
    }

    getSelectorStarCart() {
        return 'a.star';
    }

    getSelectorCopyCart() {
        return 'a.copy';
    }

    getSelectorChangeName() {
        return 'a.change_name';
    }

    events() {

        $(this.getSelectorResetCart()).on('click', (e) => {
            e.preventDefault();
            this.deleteCart( $(e.target).closest( this.getSelectorResetCart() ) );
        });

        $(this.getSelectorStarCart()).on('click', (e) => {
            e.preventDefault();
            this.starCart( $(e.target).closest( this.getSelectorStarCart() ) );
        });

        $(this.getSelectorCopyCart()).on('click', (e) => {
            e.preventDefault();
            this.duplicateCart( $(e.target).closest( this.getSelectorCopyCart() ) );
        });

        $(this.getSelectorChangeName()).on('click', (e) => {
            e.preventDefault();
            e.stopImmediatePropagation();
            this.nameChangeModal(e.currentTarget);
        });

        $('.page-basket').on('click','.btn-close',function(e){
            $('#modal').modal('hide');
        });
    }

    nameChangeModal(clicked) {
        let a = $(clicked);
        let cart_id = a.data( 'cart_id' );

        window.HegydCore.initRemoteModal(
            '#modal',
            a.prop('href'),
            function(){
                $('#cart_id').val(cart_id);
            },
            (data) => {
                if(data.hasOwnProperty('errors')){
                    if(data.errors.length > 0){
                        toastr.error(data.errors);
                    } else{

                        toastr.success(data.message);
                    }
                } else{
                    toastr.success(data.message);
                }
                location.reload()
            },
            () => {
                    toastr.error('Une erreur s\'est produite');
            })
    }

    deleteCart( $link_reset_cart ){
        this.askToDelete( $link_reset_cart.data( 'message' ), $link_reset_cart.data( 'btn_text' ),$link_reset_cart.data( 'cancel_btn_text' ), callback => {
            HegydCore.sendRequest( $link_reset_cart.attr( 'href' ), 'DELETE', {
                'cart_id': $link_reset_cart.data( 'cart_id')
            }, data => {
                location.reload();
            })
        });
    }

    starCart( $link_star_cart ){
        let uri = window.location.pathname;
        HegydCore.sendRequest( $link_star_cart.attr( 'href' ), 'PUT', {
            'cart_id': $link_star_cart.data( 'cart_id'),
            'return_templates'  : ['cart_items','head_cart'],
            'uri_from_ajax': uri,
        }, (data) => {
            this.updateCartViews( data );
            this.connectedCallback();

            if(data.hasOwnProperty('errors')){
                if(data.errors.length > 0){
                    toastr.error(data.errors);
                } else{
                    toastr.success(data.message);
                }
            } else{
                toastr.success(data.message);
            }
        },
        () => {
             toastr.error('Une erreur s\'est produite');
        })
    }

    duplicateCart( $link_copy_cart ){
        HegydCore.sendRequest( $link_copy_cart.attr( 'href' ), 'PUT', {
            //'cart_id': $link_copy_cart.data( 'cart_id')
            'return_templates'  : ['cart_items'],
        }, (data) => {
            this.updateCartViews( data );
            this.connectedCallback();
            if(data.hasOwnProperty('errors')){
                if(data.errors.length > 0){
                    toastr.error(data.errors);
                } else{
                    toastr.success(data.message);
                }
            } else{
                toastr.success(data.message);
            }
        },
        () => {
             toastr.error('Une erreur s\'est produite');
        })
    }

    updateCartViews( data ) {
        updateCartViews(data)
    }

    askToDelete( deleteText, buttonText, cancelButtonText, callback ) {
        swal({
            title: '',
            html: "<span style='color: #F17474;'>" + deleteText + "</span>",
            allowOutsideClick: true,
            type: 'warning',
            showCancelButton: true,
            closeOnConfirm: false,
            closeOnCancel: true,
            confirmButtonColor: '#ee0000',
            cancelButtonText: cancelButtonText,
            confirmButtonText: buttonText,
            showLoaderOnConfirm: true,
            preConfirm: function () {
                return new Promise(function ( resolve ) {
                    if ( callback ) {
                        callback( resolve );
                    }
                });
            }
        }).then(function () {
            swal.close();
        });
    }

}
